import styled from 'styled-components';

export const StyledErrorMessage = styled.p`
  color: ${({ theme: { colors } }) => colors['text-negative']};
  margin-top: ${({ theme: { space } }) => space[4]};
  font-family: ${({ theme: { fonts } }) => `${fonts.default}`};
  font-weight: ${({ theme: { fontWeights } }) => `${fontWeights.regular}`};
  font-size: ${({ theme: { fontSizes } }) => `${fontSizes[1]}`};
`;
